export default __webpack_public_path__ + "static/marketing-41e008d3204995458534954973d62f2c.png";